var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center","justify":"center"}},[_c('img',{attrs:{"src":"MyProfile.png","width":"600","alt":""}})])
}]

export { render, staticRenderFns }